import { Button, Input, Space, Table } from "antd";
import React, { useRef, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import Style from "./EditProductCategoryTabel.module.scss";
import { PencilSquare, Trash2Fill, TrashFill } from "react-bootstrap-icons";
const EditProductCategoryTabel = ({ data, showModal }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");

  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  function randomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  const columns = [
    {
      title: "نام محصول",
      dataIndex: "productName",
      key: "productName",
      width: "25%",
      ...getColumnSearchProps("productName", "نام محصول"),
    },
    {
      title: "تصویر محصول",
      dataIndex: "productPic",
      key: "productPic",
      width: "14%",
      ...getColumnSearchProps("productPic", "تصویر محصول"),
      render: (text, record) => (
        <div className={Style.picHolder}>
          <img
            src={`https://cdn.barest.ir/product/m/${
              record.key
            }.jpg?${randomNumberInRange(1, 1000000000000)}`}
            alt=""
          />
        </div>
      ),
    },

    {
      title: "نام برند",
      dataIndex: "brand",
      key: "brand",
      width: "20%",
      ...getColumnSearchProps("brand", "نام برند"),
    },
    {
      title: "دسته بندی ",
      dataIndex: "category",
      key: "category",
      width: "22%",
      ...getColumnSearchProps("category", "دسته بندی "),
    },
    {
      title: "عملیات",
      dataIndex: "productName",
      key: "productName",
      width: "14%",
      render: (text, record) => (
        <div className={Style.btnHolder}>
          <button
            onClick={() => showModal(selectedDataState,record)}
            className={Style.orderBtn}
          >
            <PencilSquare />
          </button>
        </div>
      ),
    },
  ];
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedDataState, setSelectedDataState] = useState([]);
  let dataSelect=[]
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
    newSelectedRowKeys.forEach(element => {
      dataSelect.push(dataSource.filter(item =>item.key===element)[0])
    });
    setSelectedDataState(dataSelect)
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  let dataSource = [];
  let index = 1;
  data &&
    data.forEach((element) => {
      dataSource.push({
        key: index,
        productName: element.name,
        productId: element.id,
        brand: element.brand_persian,
        category: element.category_persian,
      });
      index = index + 1;
    });

  return (
    <div style={{ width: "100%" }}>
      <Table
        pagination={{ pageSize: 50 }}
        scroll={{
          y: 480,
        }}
        columns={columns}
        dataSource={dataSource}
        rowSelection={rowSelection}
        loading={data === null ? true : false}
      />
    </div>
  );
};

export default EditProductCategoryTabel;
